import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import FieldType from '@app/store/FieldType';
import { scheduledDocumentPreviewDataFetched, TemplateAction } from '@app/store/template/actions';

export interface TemplateFieldLatestIdsState {
  checkboxGroup: string | null;
  signatureField: string | null;
  textField: string | null;
}

const initialState: TemplateFieldLatestIdsState = {
  checkboxGroup: null,
  signatureField: null,
  textField: null,
};

const reducer = produce((draft: Draft<TemplateFieldLatestIdsState>, action: TemplateAction) => {
  switch (action.type) {
    case scheduledDocumentPreviewDataFetched.type:
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
      return initialState;
    case TYPES.TEMPLATE_FIELD_CREATE: {
      const {
        information: { type },
        meta: { id },
      } = action.payload;

      if (type === FieldType.CHECKBOX_GROUP) {
        draft.checkboxGroup = id;
      } else if (type === FieldType.SIGNATURE_FIELD) {
        draft.signatureField = id;
      } else if (type === FieldType.TEXT_FIELD) {
        draft.textField = id;
      }
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
